import { render, staticRenderFns } from "./MaterialOpacitySelect.vue?vue&type=template&id=67236f86&scoped=true&"
import script from "./MaterialOpacitySelect.vue?vue&type=script&lang=js&"
export * from "./MaterialOpacitySelect.vue?vue&type=script&lang=js&"
import style0 from "./MaterialOpacitySelect.vue?vue&type=style&index=0&id=67236f86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67236f86",
  null
  
)

export default component.exports